import { Component, Mixins, Watch } from "vue-property-decorator";
import {
	auth,
	db,
	DEBUG,
	getVipCertificateTypeLabel,
	IVIPCertificateProduction,
	toaster,
	VIPCertificate,
	VIPCertificateRest,
	VipCertificateType,
	VIPContact,
	VIPEvent
} from "@/loader";
import CertificateStatusBadge from "./CertificateStatusBadge.vue";
import ContactEdit from "../contact/ContactEdit.vue";
import ProductionIpRow from "../production/ProductionIpRow.vue";
import ProjectDetailCard from "../project/ProjectDetailCard.vue";
import { VIPCertificateEditComponentMixin } from "@/mixins/VIPCertificateMixin";

@Component({
	components: {
		CertificateStatusBadge,
		ContactEdit,
		ProductionIpRow,
		ProjectDetailCard,
	}
})
export default class CertificateEdit extends Mixins(VIPCertificateEditComponentMixin) {
	public localContact: VIPContact | null = null;

	public focusOn(prop: string) {
		DEBUG && console.log("focus on " + prop);
		this.$set(this.focused, prop, true);
		this.setChanged(true);
	}

	public setChanged(value: boolean) {
		if (this.changed !== value) {
			this.changed = value;
			if (!value) {
				this.unfocusAll();
				Object.values(this.$refs).forEach((ref: any) => {
					if (ref.setChanged) {
						ref.setChanged(value);
					}
				});
			}
			this.$emit("changed", value);
		}
	}

	public get event(): VIPEvent | null {
		return this.item.events.slice().shift()?.event || null;
	}

	public get canCreateContact(): boolean {
		return this.canEdit && (auth.user?.capabilities.create_vip_contact || false) && !!(this.item.project?.company);
	}

	public get canEdit(): boolean {
		return (auth.user?.capabilities.edit_vip_certificate || false) &&
			(
				(this.item.isDraft && auth.user?.isSupervisorOrAbove || false)
				|| (this.item.isChecking && auth.user?.isAdministrativeOrAbove || false)
				|| (this.item.isValidating && auth.user?.isManagerOrAbove || false)
			);
	}

	public get canEditContact(): boolean {
		return (auth.user?.capabilities.create_vip_contact || false) && !!(this.item.project?.company);
	}

	// public get cips(): number[] {
	// 	DEBUG && console.error("The CertificateEdit.cips property should not be used");
	// 	return this.item.ips.map(cip => cip.fk_ip);
	// }
	// public set cips(value: number[]) {
	// 	DEBUG && console.error("The CertificateEdit.cips property should not be used");
	// 	value.forEach(fk_ip => {
	// 		if (!this.item.ips.find(cip => cip.fk_ip === fk_ip)) {
	// 			db.certificateIPS.insert({ fk_certificate: this.item.id, fk_ip });
	// 		}
	// 	});
	// 	this.item.ips.forEach(cip => {
	// 		if (!value.find(fk_ip => cip.fk_ip === fk_ip)) {
	// 			db.certificateIPS.remove(cip, true);
	// 		}
	// 	});
	// }

	public get contact(): VIPContact | null {
		return this.localContact;
	}
	public set contact(value: VIPContact | null) {
		this.localContact = value;
		this.item.datas.fk_contact = value?.id || 0;
	}

	public get contacts(): VIPContact[] {
		return this.item?.project?.company?.contacts || [];
	}

	public createContact() {
		if (!this.item || !this.item.project?.company || !this.canCreateContact) {
			return;
		}

		this.contact = db.contacts.insert({
			id: db.contacts.list.nextNewId(),
			fk_company: this.item.project.fk_company,
		});
		this.editContact();
	}

	public editContact() {
		if (this.canEditContact) {
			this.$bvModal.show("contact_modal");
		}
	}

	public hideContactModal() {
		this.$bvModal.hide("contact_modal");
	}

	public removedContact() {
		this.$bvModal.hide("contact_modal");
		this.contact = null;
	}

	public createProductionIp() {
		if (!this.canEdit || !this.item.datas?.productions) {
			return;
		}

		this.item.datas.productions.push({
			production: "",
			ip: "",
			amount: "",
		});
		this.focusOn("productions");
	}

	public upsertProductionIp(index: number) {
		if (!this.canEdit || !this.item.datas?.productions) {
			return;
		}

		this.item.datas.productions.splice(index, 0, {
			production: "",
			ip: "",
			amount: "",
		});
		this.focusOn("productions");
	}

	public sortProductionIp() {
		if (!this.canEdit || !this.item.datas?.productions) {
			return;
		}

		this.item.datas.productions.sort((a, b) => {
			return a.ip?.localeCompare(b.ip || "") || a.production?.localeCompare(b.production || "") || 0;
		});
	}

	public async cloneProductionIP() {
		if (!this.canEdit || !this.item.datas?.productions || !this.item.project) {
			return;
		}

		//Find the other certificate
		let type = this.item.isTypeWorkCertificate ? VipCertificateType.abilityCertificate : VipCertificateType.workCertificate;
		let cert = this.item.project.certificates.find(c => c.type === type && c.fk_project === this.item.fk_project);
		if (!cert) {
			await VIPCertificateRest.list({ type, fk_project: this.item.fk_project });
			cert = this.item.project.certificates.find(c => c.type === type && c.fk_project === this.item.fk_project);
		}

		if (cert) {
			this.item.datas.productions = cert.datas.productions?.map(x => ({ ...x })) || [];
			this.focusOn("productions");
			toaster.toast({
				message: "Réalisations dupliquées",
				variant: "success",
			});
		} else {
			toaster.toast({
				message: getVipCertificateTypeLabel(type) + " non trouvé",
				variant: "warning",
				noAutoHide: false,
			});
		}
	}

	public removeProductionIp(item: IVIPCertificateProduction) {
		this.item.datas.productions?.remove(item, true);
		this.focusOn("productions");
	}

	@Watch("item")
	public itemChanged(newValue: VIPCertificate | null, oldValue?: VIPCertificate | null) {
		if (newValue) {
			this.localContact = db.contacts.get(this.item.datas.fk_contact || 0);
		}
	}
}
